const timezones ={
  "Pacific/Midway": "Pacific/Midway",
  "Pacific/Honolulu": "Pacific/Honolulu",
  "America/Juneau": "America/Juneau",
  "America/Boise": "America/Boise",
  "America/Dawson": "America/Dawson",
  "America/Chihuahua": "America/Chihuahua",
  "America/Phoenix": "America/Phoenix",
  "America/Chicago": "America/Chicago",
  "America/Regina": "America/Regina",
  "America/Mexico_City": "America/Mexico_City",
  "America/Belize": "America/Belize",
  "America/Detroit": "America/Detroit",
  "America/Bogota": "America/Bogota",
  "America/Caracas": "America/Caracas",
  "America/Santiago": "America/Santiago",
  "America/St_Johns": "America/St_Johns",
  "America/Sao_Paulo": "America/Sao_Paulo",
  "America/Tijuana": "America/Tijuana",
  "America/Montevideo": "America/Montevideo",
  "America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
  "America/Godthab": "America/Godthab",
  "America/Los_Angeles": "America/Los_Angeles",
  "Atlantic/Azores": "Atlantic/Azores",
  "Atlantic/Cape_Verde": "Atlantic/Cape_Verde",
  "GMT": "GMT",
  "Europe/London": "Europe/London",
  "Europe/Dublin": "Europe/Dublin",
  "Europe/Lisbon": "Europe/Lisbon",
  "Africa/Casablanca": "Africa/Casablanca",
  "Atlantic/Canary": "Atlantic/Canary",
  "Europe/Belgrade": "Europe/Belgrade",
  "Europe/Sarajevo": "Europe/Sarajevo",
  "Europe/Brussels": "Europe/Brussels",
  "Europe/Amsterdam": "Europe/Amsterdam",
  "Africa/Algiers": "Africa/Algiers",
  "Europe/Bucharest": "Europe/Bucharest",
  "Africa/Cairo": "Africa/Cairo",
  "Europe/Helsinki": "Europe/Helsinki",
  "Europe/Athens": "Europe/Athens",
  "Asia/Jerusalem": "Asia/Jerusalem",
  "Africa/Harare": "Africa/Harare",
  "Europe/Moscow": "Europe/Moscow",
  "Asia/Kuwait": "Asia/Kuwait",
  "Africa/Nairobi": "Africa/Nairobi",
  "Asia/Baghdad": "Asia/Baghdad",
  "Asia/Tehran": "Asia/Tehran",
  "Asia/Dubai": "Asia/Dubai",
  "Asia/Baku": "Asia/Baku",
  "Asia/Kabul": "Asia/Kabul",
  "Asia/Yekaterinburg": "Asia/Yekaterinburg",
  "Asia/Karachi": "Asia/Karachi",
  "Asia/Kolkata": "Asia/Kolkata",
  "Asia/Kathmandu": "Asia/Kathmandu",
  "Asia/Dhaka": "Asia/Dhaka",
  "Asia/Colombo": "Asia/Colombo",
  "Asia/Almaty": "Asia/Almaty",
  "Asia/Rangoon": "Asia/Rangoon",
  "Asia/Bangkok": "Asia/Bangkok",
  "Asia/Krasnoyarsk": "Asia/Krasnoyarsk",
  "Asia/Shanghai": "Asia/Shanghai",
  "Asia/Kuala_Lumpur": "Asia/Kuala_Lumpur",
  "Asia/Taipei": "Asia/Taipei",
  "Australia/Perth": "Australia/Perth",
  "Asia/Irkutsk": "Asia/Irkutsk",
  "Asia/Seoul": "Asia/Seoul",
  "Asia/Tokyo": "Asia/Tokyo",
  "Asia/Yakutsk": "Asia/Yakutsk",
  "Australia/Darwin": "Australia/Darwin",
  "Australia/Adelaide": "Australia/Adelaide",
  "Australia/Sydney": "Australia/Sydney",
  "Australia/Brisbane": "Australia/Brisbane",
  "Australia/Hobart": "Australia/Hobart",
  "Asia/Vladivostok": "Asia/Vladivostok",
  "Pacific/Guam": "Pacific/Guam",
  "Asia/Magadan": "Asia/Magadan",
  "Asia/Kamchatka": "Asia/Kamchatka",
  "Pacific/Fiji": "Pacific/Fiji",
  "Pacific/Auckland": "Pacific/Auckland",
  "Pacific/Tongatapu": "Pacific/Tongatapu"
};
export default  timezones;